import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import { default_courses_request } from '@/modules/courses-requests/services';
import { CoursesRequests } from '../types';

export default class CoursesRequestsState extends BaseState {
  loading = false;
  courses_requests: CoursesRequests.Item[] = [];
  need_update = true;
  statuses: string[] = [];

  filters: CoursesRequests.RequestsFilters = {
    search: '',
    statuses: null,
    dates: null,
    only_has_unread_changes: false,
  };

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['date'],
    sortDesc: [true],
  };

  courses_request: CoursesRequests.Item = default_courses_request();
  request_need_update = false;

  // Courses

  courses: CoursesRequests.CoursesState = {
    loading: false,
    request_id: 0,
    need_update: false,
    items: [],
    table_options: { ...this.create_table_opts },
    pagination_props: { ...this.create_pagination_props },
  };

  // Staffs

  staffs: CoursesRequests.StaffsState = {
    loading: false,
    request_id: 0,
    need_update: false,
    filters: {
      courses_ids: [],
      staffs_ids: [],
    },
    table_filters: {
      courses: [],
      staffs: [],
    },
    items: [],
    table_options: { ...this.create_table_opts },
    pagination_props: { ...this.create_pagination_props },
  };

  // History

  history: CoursesRequests.HistoryState = {
    loading: false,
    request_id: 0,
    need_update: false,
    items: [],
    table_options: { ...this.create_table_opts },
    pagination_props: { ...this.create_pagination_props },
  }
}
